/**
 * monetization/query-keys — TanStack Query key factory for the
 * **platform plan** kit (`/api/plan/*`). Same contract as
 * `utils/query-keys.ts`: never inline arrays at the call site.
 *
 * They're called `plan*` and not `billing*` on purpose: in Space Academy `billing` is
 * already the institutional engine (the academy charging its students), and sharing a
 * prefix would invalidate caches that have nothing to do with it.
 */

export const planQueryKeys = {
  all: ["plan"] as const,
  config: () => ["plan", "config"] as const,
  usage: () => ["plan", "usage"] as const,
  adminConfig: () => ["admin", "monetization"] as const,
};
